module.exports = __webpack_public_path__ + "static/media/appStoreFr.ddbabcf9.svg";